import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import styled, { css } from 'styled-components';

import { CheckBox } from '~/components/checkbox/CheckBox';
import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  &:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
    padding-bottom: 4px;
  }

  &:not(:first-child) {
    padding-top: 4px;
  }
`;

export const DropdownGroup = styled(RadixDropdown.Group)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${typographyV2.bodyXs}
  padding-left: 16px;
`;

export const DropdownMenuCheckboxItem = styled(RadixDropdown.CheckboxItem)<{
  $multiselect?: boolean;
}>`
  all: unset;
  ${typographyV2.bodySm}

  ${CheckBox.Styled.CheckboxWrapper} {
    padding: 8px;
    ${({ $multiselect }) =>
      !$multiselect &&
      css`
        padding-left: 16px;
      `}
  }
`;

export const Label = styled(RadixDropdown.Label)`
  color: var(--text-soft);
  padding: 2px 16px;
  text-transform: uppercase;
`;
